/** Formats a signed unit-fraction pct as a percentage string, or "—" when null. */
export function formatPct(pct: number | null | undefined): string {
  if (pct === null || pct === undefined) return "—";
  const sign = pct < 0 ? "−" : ""; // U+2212 minus, matches the mockup
  return `${sign}${(Math.abs(pct) * 100).toFixed(1)}%`;
}

/** Scales a trend series to bar heights in percent (0–100) of the series max. */
export function sparkHeights(trend: number[]): number[] {
  const max = Math.max(0, ...trend);
  if (max === 0) return trend.map(() => 0);
  return trend.map((v) => Math.round((v / max) * 100));
}

/** True when the variance trend is rising (last > first). */
export function isGrowing(trend: number[]): boolean {
  return trend.length >= 2 && trend[trend.length - 1]! > trend[0]!;
}

/** Health-bar fill width (0–100): |pct| scaled so 5% ≈ 50, capped at 100. */
export function healthBarWidth(pct: number | null | undefined): number {
  if (pct === null || pct === undefined) return 0;
  return Math.min(100, Math.abs(pct) * 1000);
}
